<template>
    <div class="instructions">
      <h3 class="h4">Background</h3>
      <p>This exercise is designed to promote personal reflection. Although this exercise alone has proven beneficial,
         it's also a great primer for future exercises seeking clarity around strengths, values, and limiting
         beliefs.</p>
      <h3 class="h4">Instructions</h3>
      <p>You will be provided {{ sentences.length }} sentence prompts. Don't overthink your responses, the real gold to
         be discovered from this exercise will come from the unfiltered responses that first pop into your mind. If you
         feel compelled to write something different than your first thought, add this in addition to your first
         thought. Later, after you have completed all the sentences, when it is time to further reflect... you may find that the
         first thought is your "shadow" that you eagerly want to dismiss for a more "noble" response.</p>
      <div class="next-step">
        <button class="button filled accent-1 begin"
                @click.prevent="this.$parent.showInstructions = false; this.$parent.workStarted ++">
          {{ this.$parent.workStarted ? "Continue" : "Get Started" }}
        </button>
      </div>
      <p class="notice">
        <strong>Notice: </strong>
        <i>The results of this exercise are private. No data is captured nor stored throughout the process. You will be
           prompted to download a PDF of your responses when complete. This PDF is generated on demand and will not be
           saved for future review.</i>
      </p>
    </div>
</template>

<script>
export default {
  props:      {
    showInstructions: {
      type: Boolean
    },
    workStarted:         {
      type: Number
    },
    sentences:         {
      type: Array
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {},
  methods:  {}
}
</script>
